import { capitalizeEachWord } from 'helpers/format';
import {
	IPerformanceSlidersNames,
	IResultTrendsRound,
} from 'modules/admin-panel/pages/results/models';
import { SATISFACTION_LEVELS } from 'modules/admin-panel/pages/results/utils/constants';
import { getFocusAreaTypes } from 'modules/admin-panel/pages/results/helpers/getFocusAreaTypes';

export const getSatisfactionType = (
	satisfaction: number | undefined | null,
) => {
	if (typeof satisfaction !== 'number') return;
	return Object.values(SATISFACTION_LEVELS).find(
		(level) => level.min <= satisfaction && level.max >= satisfaction,
	)?.type;
};

export const getFocusAreaName = (
	round?: IResultTrendsRound,
	performanceSlidersNames?: IPerformanceSlidersNames,
) => {
	if (!round || !performanceSlidersNames) return;

	const typesArr = Object.values(getFocusAreaTypes(performanceSlidersNames));

	let min:
		| {
				name: string;
				type: string;
				id: number;
		  }
		| undefined;

	typesArr.forEach((item) => {
		if (min && min.type && round[min.type] <= round[item.type]) return;

		min = round[item.type] && item;
	});

	return capitalizeEachWord(min?.name);
};
